<div #dropdownList class="ds-dropdown-list" [ngClass]="{'ds-dropdown-list-hidden': hide, 'dark':darkMode}"
     [ngStyle]="dropdownStyle">
  <div [ngStyle]="{maxHeight: maxHeight}">
    <ng-container [ngTemplateOutlet]="template"></ng-container>
  </div>
</div>
